import { createSelector } from 'reselect';
export const getContentModel = state => state.contentModel;

// Dynamic page selectors
export const getDynamicPageDataSourceId = createSelector(getContentModel, contentModel => {
  if (contentModel) {
    return contentModel.get('dynamicPageDataSourceId');
  }
  return null;
});